import React from 'react'

import Grid from 'components/Grid'

import classes from './Summary.module.scss'

const Summary = ({ children }) => (
  <Grid item xs={12} lg={4} className="Summary">
    <div className={classes.container}>
      <div className={classes.item}>{children}</div>
    </div>
  </Grid>
)

export default Summary
